module.exports = __webpack_public_path__ + "img/CNN互動英語.bd649ae2.png";